module.exports = __webpack_public_path__ + "img/qd.228af5ac.png";